var _circle, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 87.9746,
    r: 87.5,
    fill: "#75BC6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.965 132.546C108.943 155.662 67.0676 155.477 37.251 132.097L59.1045 121.853C60.1452 121.364 61.1441 120.79 62.091 120.137C62.3785 119.94 62.6659 119.733 62.9398 119.518C65.3183 117.698 67.276 115.386 68.6794 112.741C69.7429 110.701 70.4477 108.494 70.7633 106.215C70.9826 104.742 71.0937 103.254 71.0956 101.764C71.0956 99.1955 70.9564 96.6266 70.9294 94.0532C70.9115 92.6281 70.8965 91.2044 70.8845 89.7822L71.7827 90.2313L74.1181 91.4394L75.2004 91.6236L87.7215 93.7523L101.698 96.1326L102.12 110.504L102.259 115.202L102.326 117.483V117.631L107.761 119.841L138.965 132.546Z",
    fill: "#F2A196"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.965 132.546C108.943 155.662 67.0676 155.477 37.251 132.097L59.1045 121.853C60.1452 121.364 61.1441 120.79 62.091 120.137C62.3785 119.94 62.6659 119.733 62.9398 119.518C73.5163 127.045 87.9506 131.792 100.436 126.173C103.409 124.826 106.139 122.652 107.756 119.859L138.965 132.546Z",
    fill: "url(#paint0_linear_1751_2254)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.318 117.496C97.6247 117.779 92.8866 114.137 87.9914 111.321C78.8251 106.026 73.4314 99.2223 75.1919 91.6504L87.7129 93.7792L101.689 96.1594L102.111 110.531L102.318 117.496Z",
    fill: "#E88870"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.848 45.3432C126.156 54.3253 122.397 62.7236 118.773 70.9423C114.188 81.3301 107.604 82.5651 97.5526 85.9963C95.3071 86.7688 70.9566 93.685 70.9566 95.194C70.9566 94.8661 68.5718 92.4993 65.5673 89.6206C54.7887 79.3854 51.2453 63.5724 57.6585 50.0094C66.1916 31.9958 91.6199 28.7757 109.072 33.1545C115.09 34.6635 120.965 37.0437 123.224 43.2818C123.457 43.9734 123.668 44.6606 123.848 45.3432Z",
    fill: "#00214E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.4649,
    cy: 77.2251,
    rx: 7.6348,
    ry: 7.6348,
    fill: "#F2A196"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.8901,
    cy: 77.225,
    rx: 6.83539,
    ry: 6.8354,
    fill: "#E88870"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9893 70.0215L70.9563 95.6205L100.795 113.055C105.079 114.655 109.877 112.738 111.879 108.627C116.172 99.8331 123.062 85.9513 122.154 80.7821C120.807 73.1473 117.214 70.4526 117.214 70.4526L118.71 61.4974C119.271 58.1247 119.994 54.6037 119.159 51.2129C118.202 47.3282 115.265 45.6665 112.849 42.7607C106.49 50.9524 96.0344 55.5827 86.9041 60.2759C82.193 62.7549 68.9893 70.0215 68.9893 70.0215Z",
    fill: "#F2A196"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.461 67.8389C102.425 67.9916 108.461 84.0606 108.461 84.0606L100.404 84.4558",
    stroke: "#00214E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3828 64.7265C87.5405 63.868 91.8168 63.7479 96.0162 64.3717",
    stroke: "#00214E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.903 64.7757C112.471 64.1825 115.116 63.9991 117.74 64.2323",
    stroke: "#00214E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1502 88.947C92.2743 88.7507 92.4746 88.6149 92.703 88.5723C92.9314 88.5297 93.1672 88.5841 93.3538 88.7225C94.2879 89.3782 95.9945 90.7704 98.4197 91.2509C101.725 91.9111 104.59 90.5863 105.278 91.4396C105.664 91.9201 105.192 92.5084 104.29 93.2584C102.38 94.6886 99.9728 95.2862 97.6158 94.9156C94.4361 94.3183 92.0469 90.6357 92.0469 89.3288C92.0468 89.1946 92.0824 89.0628 92.1502 88.947Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7257 69.1729C93.4698 69.1729 93.4698 73.3855 90.7257 73.4079H90.6045C87.8649 73.4079 87.8649 69.1953 90.6045 69.1729H90.7257Z",
    fill: "#00214E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.257 68.5483C115.799 68.5708 115.799 72.4556 113.257 72.478H113.145C110.599 72.478 110.599 68.5708 113.145 68.5483H113.257Z",
    fill: "#00214E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.182 34.4927C103.738 34.6725 94.3485 35.9536 85.2023 38.3101C76.0171 40.5498 67.1245 43.8536 58.7051 48.1546C60.7081 38.8895 69.8833 30.3385 82.3909 27.1993C94.8985 24.06 107.02 27.2756 113.182 34.4927Z",
    fill: "#022A61"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1751_2254",
    x1: 37.251,
    y1: 149.755,
    x2: 138.965,
    y2: 149.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16243F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6878B1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.adf4c150ed655333bb67877628d90965.svg";
export { ForwardRef as ReactComponent };